module.exports = __webpack_public_path__ + "img/bzw.160916c4.png";